const update_sql6 = [
    'drop table if exists t_group_member;',
    'create table t_group_member(tid, uid, flag, lutime, lctime, primary key(tid,uid,flag));',
];
export default update_sql6;
